import { Component, OnInit } from '@angular/core';
import { NgxSmartModalComponent, NgxSmartModalService } from '@bssh/comp-lib';
import { IRequeueRunValidationModalInput, IRequeueRunValidationModalOutput } from '@app/shared/modals/model/action-modal';
import { BaseModalComponent } from '../base-modal/base-modal.component';
import { ImportPlannedRunWarning } from '../model/import-planned-run-warning';
import { SampleSheetError } from '../components/sample-sheet-errors/sample-sheet-errors.component';

@Component({
  selector: 'app-requeue-run-errors-modal',
  templateUrl: './requeue-run-errors-modal.component.html',
  styleUrls: ['./requeue-run-errors-modal.component.scss']
})
export class RequeueRunErrorsModalComponent extends BaseModalComponent implements OnInit {
  modalType = 'RequeueRunErrors';
  title = 'Sample Sheet Validation Error(s)';
  subTitle = 'Are you sure about proceeding with requeue?';
  warnings: string[] = [];
  errors: SampleSheetError[] = [];
  
  showConfirmButton = true;
  showCloseButton = true;
  showSkipValidationCheckBox = false;
  alwaysEnableConfirmButton = false;
  ignoreValidation = false;
  isProceed = false;
  errorTypeText = 'warnings';

  constructor(
    public ngxSmartModalService: NgxSmartModalService
  ) {
    super(ngxSmartModalService);
  }

  ngOnInit() {
    super.ngOnInit();

    this.subs.sink = this.data.subscribe((modalInput: IRequeueRunValidationModalInput) => {
      if (modalInput) {
        this.title = modalInput.title || this.title;
        this.subTitle = modalInput.subTitle || this.subTitle;
        this.errors = modalInput.errors || [];
        this.showSkipValidationCheckBox = modalInput.showSkipValidationCheckBox || this.showSkipValidationCheckBox;
        this.alwaysEnableConfirmButton = modalInput.alwaysEnableConfirmButton || this.alwaysEnableConfirmButton;
        this.disableConfirmButton = !(this.alwaysEnableConfirmButton || this.ignoreValidation);
        this.errorTypeText = this.alwaysEnableConfirmButton ? 'warnings' : 'errors';
      }
    });
  }

  close(modal: NgxSmartModalComponent): void {
    const modalOutput: IRequeueRunValidationModalOutput = {
      proceed: this.isProceed,
      withoutValidation: this.ignoreValidation
    }
    this.confirm.emit(modalOutput);
    this.confirm.complete();
    super.close(modal);
  }

  /**
   * Override BaseModalComponent's accept(). Called when the confirm
   * button on modal is clicked to proceed with the action.
   * Sets isProceed to true to be emitted on close.
   * @param modal modal instance emitted as $event from eventEmitter
   */
  accept(modal: NgxSmartModalComponent) {
    this.isProceed = true;
    modal.close();
  }

  onSkipValidationCheckboxChange() {
    this.ignoreValidation = !this.ignoreValidation;
    this.disableConfirmButton = !(this.alwaysEnableConfirmButton || this.ignoreValidation);
  }

  public getWarnings(inputWarnings: ImportPlannedRunWarning[]): string[] {
    const warnings = inputWarnings.filter(x => x.severity.toLowerCase() === 'informational')
      .map(msg => msg.getRunWarningText());
    return [...new Set(warnings)]
  }

  public getErrors(inputWarnings: ImportPlannedRunWarning[]): string[] {
    const errors = inputWarnings.filter(x => x.severity.toLowerCase() !== 'informational')
      .map(msg => msg.getRunWarningText());
    return [...new Set(errors)]
  }
}
